// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0cacac2c","453":"f3ae13be","455":"482cb70b","977":"c5e77c4f"}[chunkId] + ".chunk.js";
};